export const CREATE_INTERNAL_PRODUCT = 'CREATE_INTERNAL_PRODUCT';
export type CREATE_INTERNAL_PRODUCT = typeof CREATE_INTERNAL_PRODUCT;

export interface CreateInternalProduct {
    type: CREATE_INTERNAL_PRODUCT;
    productName: string;
    description: string;
}

export function createInternalProductAction(productName: string, description: string): CreateInternalProduct {
    return {
        type: CREATE_INTERNAL_PRODUCT,
        productName,
        description
    };
}
